<template>
  <popup-dialog
    :visible="visible"
    :close-button-visible="true"
    :title="$t('labels.newModel')"
    class="model-create-popup"
    @close="close"
    @show="onShow"
  >
    <form class="p-6" @submit.prevent="create">
      <p style="text-align: center" class="mt-1">
        {{ $t("headings.createModel") }}
      </p>

      <!--<input-workspace-folder
        v-model:workspaceId="workspaceId"
        v-model:folderId="folderId"
      />-->

      <div class="column">
        <input-text
          ref="nameField"
          :label="$t('labels.name')"
          :value="data.name"
          :prevent-submit="true"
          @update:value="data.name = $event"
          @enter="descriptionField?.focus()"
        />
        <input-texteditor
          ref="descriptionField"
          :label="$t('labels.description')"
          :value="data.description"
          @update:value="data.description = $event"
        />
      </div>

      <div class="popup__buttons">
        <button
          class="button"
          type="submit"
          :disabled="!nameFilledOut || state.creating"
          :title="
            nameFilledOut ? $t('labels.create') : $t('errors.modelNeedsName')
          "
        >
          <template v-if="state.creating">
            {{ $t("messages.saving") }}
          </template>
          <template v-else>
            {{ $t("labels.create") }}
          </template>

          <limits-badge type="maxModels" style="right: -0.75rem" />
        </button>
      </div>
    </form>
  </popup-dialog>
</template>

<script setup lang="ts">
import { reactive, computed, watch, useTemplateRef } from "vue";

import PopupDialog from "@core/ui/PopupDialog.vue";
import InputTexteditor from "@core/input/TextEditor.vue";
import InputText from "@core/input/InputText.vue";
import LimitsBadge from "@core/ui/LimitsBadge.vue";
// import InputWorkspaceFolder from "@core/input/InputWorkspaceFolder.vue";
import { useWorkspaces } from "@/api/workspaces.store";
import { useModels } from "@/api/models.store";
import { showError } from "@core/ui/alert/alert";

const props = withDefaults(defineProps<{
  folder: { id: number };
  teamSlug?: string;
  organizationSlug?: string;
  visible?: boolean;
}>(), {
  visible: false,
});

const emit = defineEmits<{
  (event: "close"): void;
  (event: "create", model: { id: number | string }): void;
}>();

const nameField = useTemplateRef("nameField");
const descriptionField = useTemplateRef("descriptionField");

const { currentWorkspace } = useWorkspaces(props);
const { createModel } = useModels({});

    
const data = reactive({
  name: "",
  description: "",
  workspaceId: null as number | null,
  folderId: null as number | null
});

const state = reactive({
  creating: false
});

const nameFilledOut = computed(() => {
  return data.name && data.name.trim() != "";
});

watch(() => props.visible, (visible) => {
  if (visible) {
    data.folderId = props.folder.id;
    data.workspaceId = currentWorkspace.value!.id;
  } else {
    data.folderId = null;
    data.workspaceId = null;
    data.name = "";
    data.description = "";
  }
}, { immediate: true });
      

function onShow() {
  if (nameField.value) {
    nameField.value.focus();
  }
}

async function create() {
  console.log("create model in folder", props.folder);
  if (data.workspaceId == null || data.folderId == null) {
    console.error("no workspace / folder set");
    return;
  }

  state.creating = true;

  const modelInfo = {
    name: data.name.trim(),
    description: data.description || "",
    workspace: data.workspaceId,
    folder: data.folderId
  };

  try {
    const newModel = await createModel(modelInfo);
    emit("create", newModel);
    emit("close");
  } catch (e) {
    const error = e as Error & { code?: string };
    console.log(error);
    showError(error);
  } finally {
    state.creating = false;
  }
}
function close() {
  emit("close");
}
</script>

<style lang="scss"></style>
